import { z } from 'zod';

/**
 * Body de `POST /api/v1/proyectos/:id/auxiliares`.
 * Espeja `AssignAuxiliarDto` del backend (`usuarioId: number`).
 */
export const asignarAuxiliarSchema = z.object({
  usuarioId: z.coerce.number().int().positive('Seleccione un auxiliar de la lista.'),
});

/**
 * Query de `GET /api/v1/proyectos/usuarios-disponibles?rol=Auxiliar`.
 * El endpoint unificado decide por `rol` si lista candidatos a
 * Supervisor o a Auxiliar — este schema fija `rol = 'Auxiliar'` y solo
 * expone los filtros aplicables. Cuando `proyectoId` viene definido,
 * el backend excluye auxiliares ya asignados a ese proyecto.
 */
export const filtrosAuxiliaresDisponiblesSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
  search: z.string().trim().optional(),
  proyectoId: z.coerce.number().int().positive().optional(),
});

export type AsignarAuxiliarInput = z.infer<typeof asignarAuxiliarSchema>;
export type FiltrosAuxiliaresDisponiblesInput = z.infer<typeof filtrosAuxiliaresDisponiblesSchema>;
